import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import Alert from '../../../components/alert/Alert';
import translation from '../../../translation/translation';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 350
    }
  },
  onboardingKYC: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  label: {
    fontWeight: 600
  },
  value: {
    fontWeight: 400,
    overflow: 'auto',
    wordWrap: 'break-word'
  },
  item: {
    display: 'grid',
    width: '100%',
    gap: 4,
    gridTemplateColumns: '8rem 1fr'
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer'
  }
}));

function OnboardingKYC(props) {
  const { getOnboardingKYC, resource } = props;
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [onboardingKYC, setOnboardingKYC] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (resource && resource.user && resource.user.id) {
      setError(null);
      setLoading(true);

      getOnboardingKYC(
        resource.user.id,
        (success) => {
          setLoading(false);

          if (success) {
            setOnboardingKYC(success);
          }
        },
        (err) => {
          setLoading(false);
          setOnboardingKYC(null);
          setError(
            typeof err === 'string'
              ? err
              : translation().core.list.dialogs.custom_list_actions.onboarding_kyc.callbacks.error
          );
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="OnboardingKYC">
      <div className={classes.root}>
        {onboardingKYC && (
          <div className={classes.onboardingKYC}>
            <div className={classes.item}>
              <Typography className={classes.label}>Account ID:</Typography>
              <span className={classes.value}>
                {onboardingKYC.account_id ? onboardingKYC.account_id : 'N/A'}
              </span>
            </div>
            <div className={classes.item}>
              <Typography className={classes.label}>Onboarding URL:</Typography>
              <span className={classes.value}>
                {onboardingKYC.onboarding_url ? (
                  <a
                    href={onboardingKYC.onboarding_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.link}
                  >
                    {onboardingKYC.onboarding_url}
                  </a>
                ) : (
                  'N/A'
                )}
              </span>
            </div>
            <div className={classes.item}>
              <Typography className={classes.label}>Dashboard URL:</Typography>
              <span className={classes.value}>
                {onboardingKYC.dashboard_url ? (
                  <a
                    href={onboardingKYC.dashboard_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.link}
                  >
                    {onboardingKYC.dashboard_url}
                  </a>
                ) : (
                  'N/A'
                )}
              </span>
            </div>
          </div>
        )}
        {error && (
          <Alert
            type="danger"
            style={{ marginTop: 10 }}
            status={translation().commons.alerts.error}
            text={error}
          />
        )}
        {isLoading && (
          <div className="loader-wpr">
            <CircularProgress color="primary" size={25} />
            <p>{translation().core.list.dialogs.custom_list_actions.onboarding_kyc.loading}</p>
          </div>
        )}
      </div>
    </div>
  );
}

OnboardingKYC.propTypes = {
  getOnboardingKYC: PropTypes.func.isRequired,
  resource: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    })
  })
};

export default OnboardingKYC;
